module.exports = __webpack_public_path__ + "img/resultslist.f86566e2.svg";